import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { refreshCertification } from '../../utils/certificationCache';
import { IRQCallbacks } from '../../types/my-types';
import { IFieldUpdateParams } from '../../api/types';

interface IFieldUpdate {
  id: string;
  data: IFieldUpdateParams;
}

export const useFieldUpdate = (callbacks?: IRQCallbacks, trainingSetId?: string) => {
  const glynt = useGlynt();
  const cache = useQueryClient();

  return useMutation({
    mutationFn: async (data: IFieldUpdate) => await (await glynt).fields.update(data.id, data.data),
    ...callbacks,

    onSettled: async (data, error) => {
      // Only on success: a failed update revoked nothing server-side.
      if (!error) {
        refreshCertification(cache, trainingSetId);
      }

      // Invalidate all mark validation queries when a field is updated
      // (since field config changes can affect validation)
      cache.invalidateQueries({
        queryKey: ['mark-validation']
      });

      // Call the original onSettled if provided
      callbacks?.onSettled?.();
    }
  });
};
